import { render } from "./Children.vue?vue&type=template&id=3bdb6d4c"
import script from "./Children.vue?vue&type=script&lang=js"
export * from "./Children.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__